// ELS CANVIS O MILLORES FETS EN AQUEST FITXER CAL TRASLLADAR-LOS AL PLAYER.JSX DE 3CAT
import { getImatge } from '../../../components/3catinfo/Imatge';
import { setItem, getStorageValue, setStorageValue, removeStorageValue } from '@portal-internet/core';
import clsx from 'clsx';
import Icona from '../../../components/3catinfo/ui/Icona/Icona';
import useRmpLoginStateInterop from '../../../hooks/useRmpLoginStateInterop';
import useStartOverHelper from '../../../hooks/useStartOverHelper';
import { useUser } from '../../../hooks/useUser';
import { useViewport } from '../../../hooks/3catinfo/useViewport';
import __get from 'lodash/get';
import __isEmpty from 'lodash/isEmpty';
import __isUndefined from 'lodash/isUndefined';
import { useRouter } from 'next/router';
import Script from 'next/script';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { getCropByViewport } from '../../../utils/imatgesHelper';
import { setGlobalEvar } from '../Audiencies/audiencies-datalayer';
import BotonsAccesibilitat from './Accesibilitat/BotonsAccesibilitat';
import FullScreen from './FullScreen';
import VideoBase from './VideoBase';
import styles from './player.module.scss';
import { constructMediaUrl, getParametresExtra } from './playerHelpers';
import Head from 'next/head';

const _isDirecte = (id) => {
    return [
        'cr',
        'ci',
        'cm',
        'ic',
        '324',
        'sx3',
        'tv3',
        'oca1',
        'oca2',
        'oca3',
        'oca4',
        'ocr1',
        'esport3',
        '33',
        'c33',
        'tv3cat',
        'tvc',
        'tvi',
        'fc1',
        'fc2',
        'fc3',
        'fc4',
        'fc5',
        'fc6',
        'tem1',
        'tem2',
        'pucfc1',
        'pucfc2',
        'pucfc3',
        'pucfc4',
        'pucfc5',
        'pucfc6',
        'bondiatv',
        'beauties'
    ].includes(id);
};

const Player = forwardRef(function Player(props, publicRef) {
    const {
        routerQuery,
        ocultaInfo,
        updateInfo,
        adPlaying,
        updateAudioDesc,
        desactivaAudioDesc,
        estils,
        playerError,
        state,
        endPubDate,
        imatges,
        pushMediaModel,
        playerControllerInstance,
        onNextVideo,
        mostrarBotonsAccessibilitat,
        disabledDblClickFullscreen,
        tipus = 'video',
        playerVideoTagId = 'view1',
        versio = 'vast',
        mostraRelacionats = true,
        autofullscreen = false,
        autoPlay = false,
        mostraCasting = true,
        parametresExtraWs = '',
        isPopup = false,
        embed = false,
        className = null,
        eliminarPrimerTabIndex = false
    } = props;

    const fixedPlayerRef = useRef(false);
    const containerRef = useRef(null);
    const bitMovinPosterRef = useRef(null);
    //const { setClickOrigin, resetClickOriginData } = useContext(HistoryContext);
    let { hashStartOverParams } = props;

    let id = props?.id || routerQuery?.id;
    let directe = props?.id ? props?.directe : _isDirecte(id);
    const router = useRouter();

    const { ...userData } = useUser();
    const { setRmpLoginState } = useRmpLoginStateInterop();
    useEffect(() => {
        // Actualitza l'estat del LOGIN per al marcatge d'audiències
        // realitzat per Jitpub\Modul\RmpBundle (TVCPlayerCore)
        setRmpLoginState(userData);
    }, [userData, setRmpLoginState]);

    const [isActive, setIsActive] = useState(true);
    const [isGeoBlocked, setIsGeoBlocked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [modelFetched, setModelFetched] = useState(false);
    const [mediaModel, setMediaModel] = useState(null);
    const [globalController, setGlobalController] = useState(null);
    const [titol, setTitol] = useState(null);
    const [durada, setDurada] = useState(null);
    const [edat, setEdat] = useState(null);
    const [aud, setAud] = useState(null);
    const [next, setNext] = useState(false);
    const [fixedPlayer, setFixedPlayer] = useState(false);
    const [closeFlotant, setCloseFlotant] = useState(true);
    const [nomProg, setNomProg] = useState(null);
    const [controlsAccessibles] = useState(mostrarBotonsAccessibilitat);
    const [textAudPlayer, setTextAudPlayer] = useState('Activa');
    const [audioDescPlayer, setAudioDescPlayer] = useState(false);
    const [inactiveButtons, setInactiveButtons] = useState(clsx({ [styles.inactiveButtons]: directe }));
    const [inactiveStartOverButton, setInactiveStartOverButton] = useState(clsx({ [styles.inactiveStartOverButton]: false }));
    const [startOverPlayer, setStartOverPlayer] = useState(null);
    const [reloadStartOver, setReloadStartOver] = useState(null);
    const BMPLAYER_3CAT_MUTED = 'bmplayer.3cat.muted';
    const fullscreenRootRef = useRef(null);

    useEffect(() => {
        fixedPlayerRef.current = fixedPlayer;
    }, [fixedPlayer]);

    useEffect(() => {
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                const videoElement = document.querySelector('#' + playerVideoTagId);
                const playerElement = videoElement?.parentElement;
                const playerElementActive = videoElement?.dataset.playerActive;
                if (playerElementActive) {
                    const isFocusInsidePlayer = playerElement?.contains(document.activeElement);
                    if (isFocusInsidePlayer) {
                        e.stopImmediatePropagation();
                    }
                }
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useImperativeHandle(publicRef, () => ({
        play(time = 0) {
            globalController?.sendCommand('currentTime', time);
            globalController?.sendCommand('play');
        },
        inici(time = 0) {
            globalController?.sendCommand('currentTime', time);
        },
        continuePlay() {
            globalController?.sendCommand('play');
        },
        pause() {
            globalController?.sendCommand('pause');
        },
        getCurrentAudioTrack() {
            return getCurrentAudioTrack(globalController);
        },
        activaStartOver(activa) {
            let data = {
                actiu: activa
            };
            handleStartOver(data);
        },
        handleAudioDesc() {
            changeAudioDescPlayer();
        },
        isMuted() {
            return globalController?.sendCommand('isMute');
        },
        async mute() {
            const isMuted = await getStorageValue(BMPLAYER_3CAT_MUTED);
            if (isMuted === 'true') {
                removeStorageValue(BMPLAYER_3CAT_MUTED, false, '.3cat.cat');
            } else {
                setStorageValue(BMPLAYER_3CAT_MUTED, 'true', { path: '/', domain: '.3cat.cat', expires: 1 });
            }
            globalController?.sendCommand('mute');
        }
    }));

    const { app, frontal, agrupacio, ranking } = router.query;

    const params = {
        profile: app,
        frontal: frontal,
        agrupacio: agrupacio,
        ranking: ranking
    };
    const { viewport, zoomNavigator } = useViewport();

    const dataParametresExtraWs = getParametresExtra(parametresExtraWs, params);

    const dataAutoFullScreen = router.query['autofullscreen'] === 'yes' || autofullscreen;
    const dataMostraRelacionats = router.query['mostra_relacionats'] === 'yes' || mostraRelacionats;
    const dataAudiodesc = router.query['ad'] === 'yes' || router.query['ad'] === 'true' || null;
    const dataAutoPlay =
        router.query['autoplay'] === 'false'
            ? false
            : router.query['autoplay'] === 'yes' || router.query['autoplay'] === 'true' || autoPlay;
    const dataDelayed = router.query['temps_inici'] ? router.query['temps_inici'] : '0';

    const mediaws = 'https://api-media.3cat.cat/pvideo/media.jsp';
    const [offset] = useState(0);

    const GEO_ZONE_DICTIONARY_CHANNELS = {
        CATALUNYA: 'tv3',
        ESPANYA: 'tvc',
        TOTS: 'tvi'
    };

    const stylesRmplayer = clsx({
        'M-rmp': true,
        'C-audio': (tipus === 'audio' || tipus === 'audio_tts') && estils !== 'noticia' && !embed,
        'C-standaloneAudio': ((estils === 'noticia' || embed) && tipus === 'audio') || tipus === 'audio_tts',
        'C-directe': directe,
        'C-popup': isPopup,
        [styles.rmplayer]: true,
        [styles.rmplayerAudio]: tipus === 'audio' || tipus === 'audio_tts',
        [styles[estils]]: !!estils,
        [styles.embed]: embed,
        [styles.popup]: isPopup,
        [styles.rmpDirecte]: directe,
        [styles.zoom400]: zoomNavigator > 3,
        [className]: !!className
    });

    const nextVideo = (event) => {
        setNext(true);
        setTextAudPlayer('Activa');
        setAudioDescPlayer(false);
        if (desactivaAudioDesc !== undefined) {
            desactivaAudioDesc();
        }

        router.replace({
            pathname: '/3cat/' + event.detail.slug + '/video/' + event.detail.idint + '/',
            query: null
        });
    };

    const removeTabIndex = (event) => {
        const target = event.target;
        if (target.id === playerVideoTagId && target.getAttribute('tabindex') === '0') {
            event.preventDefault();
            const focusableElements = Array.from(
                document.querySelectorAll("a, button, input, textarea, select, [tabindex]:not([tabindex='-1'])")
            );
            const currentIndex = focusableElements.indexOf(target);
            if (currentIndex !== -1) {
                const nextElement = focusableElements[currentIndex + 1] || focusableElements[0];
                nextElement.focus();
            }
        }
    };
    const getCurrentAudioTrack = (controller) => {
        try {
            return controller.sendCommand('getCurrentAudioTrack');
        } catch (error) {
            return 0;
        }
    };

    const objParams = useRef({
        tipus,
        dataParametresExtraWs,
        directe,
        mediaws,
        versio,
        id,
        offset
    });
    const hasAssignedOffset = useRef(false);
    const { getHashParamsFromUrl } = useStartOverHelper();

    if (hashStartOverParams == null) {
        hashStartOverParams = getHashParamsFromUrl(router.asPath.split('#')[1]);
        if (hashStartOverParams?.hashStartOverParams) {
            hashStartOverParams = hashStartOverParams?.hashStartOverParams;
        }
    }

    const isStartOver = !!hashStartOverParams?.start || undefined;

    const accessKey = (command) => {
        if (command === 'play') {
            globalController?.sendCommand('paused')
                ? globalController?.sendCommand('play')
                : globalController?.sendCommand('pause');
        }
        if (command === 'volumeUp') {
            globalController?.sendCommand('volume', globalController?.sendCommand('volume') + 0.2);
        }
        if (command === 'volumeDown') {
            const targetVolume =
                globalController?.sendCommand('volume') - 0.2 === 0 ? -1 : globalController?.sendCommand('volume') - 0.2;
            globalController?.sendCommand('volume', targetVolume);
        }
        if (command === 'mute') {
            globalController?.sendCommand('mute');
        }
    };

    useEffect(() => {
        if (embed && state === 'DESP') {
            const msg =
                tipus === 'audio' || tipus === 'audio_tts' ? 'Aquest àudio està despublicat' : 'Aquest vídeo està despublicat';
            setErrorMessage(msg);
            setIsActive(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state, endPubDate]);

    useEffect(() => {
        objParams.current = {
            tipus,
            dataParametresExtraWs,
            directe,
            mediaws,
            versio,
            id,
            offset
        };

        if (!isStartOver) {
            hasAssignedOffset.current = false;
        }

        if (isStartOver && hashStartOverParams?.desplacament && !hasAssignedOffset.current) {
            //tot el useEffect es per setejar el valor inicial per fer la crida a la media.jsp com desplacament
            objParams.current.offset = hashStartOverParams?.desplacament;
            hasAssignedOffset.current = true;
        }
    }, [tipus, dataParametresExtraWs, directe, mediaws, versio, id, offset, isStartOver, hashStartOverParams?.desplacament]);

    const handlerCloseFlotant = () => {
        setCloseFlotant(false);
        setFixedPlayer(false);
        const playerElement = document.querySelector('#' + playerVideoTagId);
        playerElement.dataset.playerActive = false;
        globalController?.sendCommand('pause');
    };

    const setupPlayer = (id) => {
        setNext(false);
        let model, paused, relatedOpen, imatgeKeyframe, presentador;

        if (directe) {
            if (tipus === 'audio') {
                model = new window.TVCEndPoints.AudioLiveModel({ idint: id });
                objParams.current.urlBase = window.URLS.AUDIOINFOLIVEPERIDJSON;
            } else {
                model = new window.TVCEndPoints.VideoLiveModel({ idint: id });
                objParams.current.urlBase = window.URLS.VIDEOINFOLIVEPERIDJSON;
            }
            /*-overwrite TVCPlayerCore methods for Startover, etc... -*/
            model.url = () => {
                let url = constructMediaUrl(objParams.current);
                if (isStartOver) {
                    const urlModif = new URL(url);
                    urlModif.searchParams.set('so_id', hashStartOverParams.so_id);
                    urlModif.searchParams.set('start', hashStartOverParams.start);
                    //desplacament va amb el offset dels objParams
                    url = urlModif.href;
                }
                return url;
            };
            model.parse = (data) => {
                imatgeKeyframe = data?.keyframes !== undefined ? data?.keyframes[0]?.url : undefined;
                presentador = data?.informacio?.arafem?.presentador;
                model.update(data);
                clearTimeout(model.nextUpdateTimeout);
                model.nextUpdateTimeout = setTimeout(() => {
                    model.fetch({ success, error });
                }, model.getNextUpdateTime());
                return model;
            };
        } else {
            //VOD
            if (tipus === 'audio_tts') {
                model = new window.TVCEndPoints.AudioModel({ idint: id });
                objParams.current.urlBase = window?.URLS?.AUDIOTTSINFOPERIDJSON;
            } else if (tipus === 'audio') {
                model = new window.TVCEndPoints.AudioModel({ idint: id });
                objParams.current.urlBase = window?.URLS?.AUDIOINFOPERIDJSON;
            } else {
                model = new window.TVCEndPoints.MediaModel({ idint: id });
                objParams.current.urlBase = window?.URLS?.VIDEOINFOPERIDJSON;
            }
            objParams.current.id = id;
            model.url = constructMediaUrl(objParams.current);
        }

        const playerController = new window.TVCPlayerCore.PlayerController(playerVideoTagId, model, true);

        setGlobalController(playerController);
        if (playerControllerInstance) playerControllerInstance(playerController);
        const STYLES = 'width=480, height=320, titlebar=0, resizable=0, scrollbars=0, location=0';
        const TEMPS_INICI = '&temps_inici=';

        const openPopup = ({ detail }) => {
            const idPopup = detail?.id;
            if (__isEmpty(idPopup) || !idPopup.includes(`-${id}`)) {
                return;
            }
            let currentTime = playerController?.sendCommand('currentTime') / 1000.0,
                playing = playerController?.sendCommand('paused') ? 'false' : 'true',
                slug = router?.query?.slug || 'audio',
                canal = router?.query?.canal || id;
            if (directe) {
                currentTime = 0;
                window.open(
                    '/3catinfo/directes/' + canal + '/popup/?' + 'autoplay=' + playing + TEMPS_INICI + currentTime,
                    '',
                    STYLES
                );
            } else if (tipus === 'audio_tts') {
                window.open(
                    '/3catinfo/' + slug + '/audio-tts/' + id + '/popup/?' + 'autoplay=' + playing + TEMPS_INICI + currentTime,
                    '',
                    STYLES
                );
            } else {
                window.open(
                    '/3catinfo/' + slug + '/audio/' + id + '/popup/?' + 'autoplay=' + playing + TEMPS_INICI + currentTime,
                    '',
                    STYLES
                );
            }
        };

        const shouldSwitchToMinPlayer = (currentScrollPos, switchToMinPlayerPosUp, switchToMinPlayerPosDown) => {
            const playerElement = document.querySelector('#' + playerVideoTagId);
            return (
                playerElement?.dataset.playerActive === 'true' &&
                closeFlotant &&
                (currentScrollPos > switchToMinPlayerPosDown || currentScrollPos < switchToMinPlayerPosUp)
            );
        };

        const focusOnButton = (containerRef) => {
            if (containerRef.current) {
                containerRef.current.querySelector('[tabindex="0"]')?.focus();
            }
        };

        const adjustPlayer = () => {
            if (playerController?.sendCommand('getViewMode') !== 'pictureinpicture') {
                const container = $('#videoviewbase_' + playerVideoTagId);
                const upperEdge = container.offset()?.top;
                const lowerEdge = upperEdge + container.height();
                const currentScrollPos = document.body.scrollTop || document.documentElement.scrollTop;
                const switchToMinPlayerPosUp = upperEdge - window.innerHeight / 1.5;
                const switchToMinPlayerPosDown = lowerEdge - window.innerHeight / 3;
                if (shouldSwitchToMinPlayer(currentScrollPos, switchToMinPlayerPosUp, switchToMinPlayerPosDown)) {
                    setFixedPlayer(true);
                    if (fixedPlayerRef.current) {
                        focusOnButton(containerRef);
                    }
                } else {
                    setFixedPlayer(false);
                    setCloseFlotant(true);
                }
            }
        };

        //playerController.on('related-playlist-click', () => {
        //    resetClickOriginData();
        //    setClickOrigin('name', 'Relacionats Player');
        //});

        playerController.on('changevideo', (ev) => {});
        playerController.on('loadedmetadata', (ev) => {
            if (dataAudiodesc && !audioDescPlayer) {
                changeAudioDescPlayer();
            }
        });
        playerController.on('openPopup', openPopup);
        window.addEventListener('openPopup', openPopup);
        window.addEventListener('scroll', adjustPlayer);

        playerController.on('sas_adstart', () => {
            adPlaying(true);
        });
        playerController.on('sas_adend', () => {
            adPlaying(false);
        });
        playerController.on('sas_adcreativitybegin', () => {
            adPlaying(true);
        });
        playerController.on('sas_adcreativityend', () => {
            adPlaying(false);
        });
        playerController.on('playlistend', (ev) => {
            if (onNextVideo) onNextVideo({ currentVideo: id });
            else if (tipus === 'video' && directe !== true && bitMovinPosterRef.current) {
                const imageUrl = bitMovinPosterRef.current?.style.backgroundImage
                    .replace(/url\(["']?/, '')
                    .replace(/["']?\)/, '');
                const playerContainer = document.querySelector('#' + playerVideoTagId);
                const overlayElement = playerContainer?.querySelector('.bmpui-ui-recommendation-overlay');
                if (overlayElement && imageUrl) {
                    overlayElement.style.background = `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${imageUrl})`;
                    overlayElement.style.backgroundSize = 'cover';
                    overlayElement.style.zIndex = '2';
                }
            }
        });
        playerController.on('playliststart', () => {});
        playerController.on('playlistready', (ev) => {
            if (AppPlayerPlugin) {
                let player = $('#' + playerVideoTagId).parents('.tvcplayer');
                let data = ev?.params !== undefined ? ev?.params : ev;
                AppPlayerPlugin(player, playerController, data);
            }
        });
        playerController.on('error', () => {});
        playerController.on('timeupdate', (ev) => {
            setItem({
                id: id,
                tipology: tipus === 'audio' || tipus === 'audio_tts' ? 'WCR_AUDIO_MM' : 'DTY_VIDEO_MM',
                tc: Math.round(ev.params.ms / 1000) //seconds
            });
        });
        playerController.on('ready', () => {
            const playerContainer = document.querySelector('#' + playerVideoTagId);
            const posterPlayer = playerContainer?.getElementsByClassName('bitmovinplayer-poster')[0];
            if (posterPlayer && tipus === 'video' && directe !== true) {
                bitMovinPosterRef.current = posterPlayer;
            }
        });
        playerController.on('play', () => {
            if (tipus === 'video' && directe !== true && bitMovinPosterRef) {
                const playerContainer = document.querySelector('#' + playerVideoTagId);
                const overlayElement = playerContainer?.querySelector('.bmpui-ui-recommendation-overlay');
                if (overlayElement) {
                    overlayElement.style.zIndex = 'unset';
                }
            }
            if (document.querySelector('#' + playerVideoTagId)) {
                const playerElement = document.querySelector('#' + playerVideoTagId);
                playerElement.dataset.playerActive = true;
            }
            if (hashStartOverParams && hashStartOverParams.audio_index !== undefined) {
                let currentAudioTrack = getCurrentAudioTrack(playerController);
                if (currentAudioTrack !== Number(hashStartOverParams.audio_index)) {
                    playerController.sendCommand('setCurrentAudioTrack', Number(hashStartOverParams.audio_index));
                }
            }
            if (ocultaInfo) {
                ocultaInfo(true);
            }
            if (directe) {
                let currentTime = Math.ceil(playerController.sendCommand('getCurrentTimeSec'));
                if (currentTime < -20) {
                    setInactiveButtons(clsx({ [styles.inactiveButtons]: false }));
                }
            }
            if (tipus === 'audio_tts' && !fixedPlayer && playerController.sendCommand('isMute')) {
                playerController.sendCommand('mute');
                if (playerController.sendCommand('volume') === 0) playerController.sendCommand('volume', 0.2);
            }
            const fixedPlayerCotainer = document.getElementsByClassName('fixed-player');
            if (fixedPlayerCotainer.length > 0) {
                const fixedPlayer = fixedPlayerCotainer[0].getElementsByClassName('bitmovinplayer-container')[0];
                if (fixedPlayer?.id !== playerVideoTagId) {
                    fixedPlayer.player.pause();
                }
            }
            // pausar resta players
            const playersContainers = document.getElementsByClassName('bitmovinplayer-container');
            if (playersContainers.length > 0) {
                Array.from(playersContainers).forEach((otherPlayer) => {
                    if (playerVideoTagId !== otherPlayer.id) {
                        otherPlayer.player.pause();
                        otherPlayer.dataset.playerActive = false;
                    }
                });
            }
        });
        playerController.on('pause', () => {
            const fixedPlayerContainer = document.getElementsByClassName('fixed-player');
            if (fixedPlayerContainer.length === 0) {
                const playerElement = document.querySelector('#' + playerVideoTagId);
                playerElement.dataset.playerActive = false;
            }
            if (!relatedOpen && ocultaInfo) {
                ocultaInfo(false);
            }
            if (directe) {
                setInactiveButtons(clsx({ [styles.inactiveButtons]: false }));
            }
        });
        playerController.on('related-playlist-show', () => {
            paused = playerController.sendCommand('paused');
            relatedOpen = true;
            if (ocultaInfo) {
                ocultaInfo(true);
            }
        });
        playerController.on('related-playlist-close', () => {
            relatedOpen = false;
            if (paused && ocultaInfo) {
                ocultaInfo(false);
            }
        });
        playerController.on('seeked', () => {
            if (directe) {
                //startover té directe true.
                const currentTime = Math.ceil(playerController.sendCommand('getCurrentTimeSec') / 60);
                if (currentTime < 0) {
                    setInactiveButtons(clsx({ [styles.inactiveButtons]: false }));
                } else {
                    setInactiveButtons(clsx({ [styles.inactiveButtons]: true }));
                }
                objParams.current.offset = currentTime * -1;
                model.fetch({ success, error });
            }
        });

        const success = (response) => {
            setModelFetched(true);
            setMediaModel(response);
            if (pushMediaModel) pushMediaModel(response);
            if (directe) {
                let titol = __get(response, 'attributes.informacio.attributes.arafem.attributes.titol') || '',
                    titol_complet = __get(response, 'attributes.informacio.attributes.arafem.attributes.titol_complet') || '',
                    programa = __get(response, 'attributes.informacio.attributes.arafem.attributes.programa') || '',
                    codiEtic =
                        __get(response, 'attributes.informacio.attributes.arafem.attributes.codi_etic.attributes.id') || '',
                    entradeta = __get(response, 'attributes.informacio.attributes.arafem.attributes.descripcio') || '',
                    despresPrograma = __get(response, 'attributes.informacio.attributes.despresfem.programa') || '',
                    despresTitol = __get(response, 'attributes.informacio.attributes.despresfem.titol') || '',
                    despresHora = __get(response, 'attributes.informacio.attributes.despresfem.data_emissio.utc') || '',
                    startOverParams = __get(response, 'attributes.startover.params') || false;
                if (document.querySelector('#' + playerVideoTagId + ' .fullscreenrow')) {
                    renderFullscreen(titol, programa, codiEtic);
                }
                if (startOverParams && !isStartOver) {
                    setInactiveStartOverButton(clsx({ [styles.inactiveStartOverButton]: false }));
                    setStartOverPlayer(startOverParams);
                } else {
                    setInactiveStartOverButton(clsx({ [styles.inactiveStartOverButton]: true }));
                    setInactiveButtons(clsx({ [styles.inactiveButtons]: false }));
                    setStartOverPlayer(false);
                }
                if (isStartOver) {
                    setInactiveStartOverButton(clsx({ [styles.inactiveStartOverButton]: false }));
                }
                if (!__isUndefined(updateInfo)) {
                    let imatgeKeyCrop = imatgeKeyframe !== undefined ? cropImatge(imatgeKeyframe) : '';
                    let offset = objParams?.current?.offset || 0;
                    const dades = {
                        titol,
                        titol_complet,
                        entradeta,
                        despresPrograma,
                        despresTitol,
                        despresHora,
                        presentador,
                        imatgeKeyCrop,
                        offset,
                        ...(startOverParams && { startOverParams })
                    };
                    updateInfo(dades);
                }
            }
        };
        const error = () => {
            console.warn('error on media.jsp response');
        };
        model.fetch({ success, error });
        return () => {
            playerController.off('changevideo', () => {});
            playerController.off('loadedmetadata', () => {});
            playerController.off('sas_adstart', () => {});
            playerController.off('sas_adend', () => {});
            playerController.off('sas_adcreativitybegin', () => {});
            playerController.off('sas_adcreativityend', () => {});
            playerController.off('playlistend', () => {});
            playerController.off('playliststart', () => {});
            playerController.off('playlistready', () => {});
            playerController.off('error', () => {});
            playerController.off('timeupdate', () => {});
            playerController.off('play', () => {});
            playerController.off('pause', () => {});
            playerController.off('seeked', () => {});
            playerController.off('related-playlist-show', () => {});
            playerController.off('related-playlist-close', () => {});
            playerController.off('ready', () => {});
            playerController.off('openPopup', () => {});
            window.removeEventListener('openPopup', openPopup);
            window.removeEventListener('scroll', adjustPlayer);
            clearTimeout(model.nextUpdateTimeout);
            playerController.destroy();
        };
    };

    const cropImatge = (imatge) => {
        if (__isUndefined(imatge) || !imatge.includes('img.ccma.cat') || !imatge.includes('img.3cat.cat')) return imatge;
        let crop = '';

        switch (viewport) {
            case 'VP_MOBILE':
            case 'VP_SMALL':
                crop = '670';
                break;
            case 'VP_REGULAR':
                crop = '1014';
                break;
            case 'VP_LARGE':
            default:
                crop = '1920';
                break;
        }

        const splitimatge = imatge?.split('.');
        const extensio = `.${splitimatge[splitimatge.length - 1]?.trim()}`;
        return imatge.replace(extensio, `_${crop}${extensio}`);
    };

    const changeAudioDescPlayer = () => {
        setAudioDescPlayer(!audioDescPlayer);
        let textAud = audioDescPlayer ? 'Activa' : 'Desactiva';
        setTextAudPlayer(textAud);
        if (updateAudioDesc !== undefined) {
            updateAudioDesc();
        }
    };

    const renderFullscreen = (titolFS, programaFS, codiEtic) => {
        let fsWraper = document.querySelector('#' + playerVideoTagId + ' .fullscreenrow');
        if (!fsWraper) return;

        // Si no existe el root, crearlo
        if (!fullscreenRootRef.current) {
            fullscreenRootRef.current = createRoot(fsWraper);
        }

        // Reutilizar el mismo root para renderizar
        fullscreenRootRef.current.render(
            <FullScreen
                titol={titol || titolFS}
                nomProg={nomProg || programaFS}
                changeAudioDesc={changeAudioDescPlayer}
                textAud={textAudPlayer}
                edat={edat || codiEtic}
                aud={aud}
            />
        );
    };

    useEffect(() => {
        if (mediaModel) {
            if (directe || _isDirecte(id)) {
                const duradaMediaModel =
                    __get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.durada.text') ||
                    __get(mediaModel, 'attributes.informacio.attributes.arafem.durada.text');
                setIsActive(duradaMediaModel !== '');
                const dretsMediaModel =
                    __get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.drets.text') ||
                    __get(mediaModel, 'attributes.informacio.attributes.arafem.drets.text');
                setErrorMessage(dretsMediaModel);
                setTitol(__get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.titol'));
                setNomProg(__get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.programa'));
                setEdat(__get(mediaModel, 'attributes.informacio.attributes.arafem.attributes.codi_etic.attributes.id'));
            } else {
                setTitol(__get(mediaModel, 'attributes.informacio.attributes.titol'));
                setDurada(__get(mediaModel, 'attributes.informacio.attributes.durada.attributes.milisegons'));
                setNomProg(__get(mediaModel, 'attributes.informacio.attributes.programa'));
                setEdat(__get(mediaModel, 'attributes.informacio.attributes.codi_etic.attributes.id'));
            }
            let videoTag = $('#' + playerVideoTagId).parents('.tvcplayer');
            let variants = __get(mediaModel, 'attributes.variants');
            setAud(variants !== undefined && variants?.length > 0);
            let imatgePlayer =
                __get(mediaModel, 'attributes.keyframes.models[0].attributes.url') ||
                __get(mediaModel, 'attributes.imatges.models[0].attributes.url');
            if (directe) {
                if (imatges) {
                    imatgePlayer = getImatge(
                        imatges,
                        'web_player_poster_background',
                        null,
                        getCropByViewport(viewport),
                        null
                    ).src;
                } else {
                    imatgePlayer =
                        __get(mediaModel, 'attributes.imatges.models[0].attributes.url') ||
                        __get(mediaModel, 'attributes.keyframes.models[0].attributes.url');
                }
            }
            videoTag.data('imatge_poster', cropImatge(imatgePlayer));
            if (tipus === 'audio_tts') {
                videoTag.data('type', 'audio');
            }

            videoTag.data('subtitles', __get(mediaModel, 'attributes.subtitols'));
            videoTag.data('sprites', __get(mediaModel, 'attributes.sprites'));
            videoTag.data('durada', __get(mediaModel, 'attributes.informacio.attributes.durada.attributes.milisegons'));
            if (tipus === 'video') {
                videoTag.data('title', __get(mediaModel, 'attributes.informacio.attributes.titol'));
            }

            let geoBlocked = __get(mediaModel, 'attributes.geoblocked');
            if (geoBlocked) {
                setIsGeoBlocked(geoBlocked);
                setErrorMessage('Aquest contingut no està disponible en la teva ubicació');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mediaModel]);

    useEffect(() => {
        if (!__isEmpty(playerError)) {
            errorMessage !== '' ? playerError(true) : playerError(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMessage]);

    useEffect(() => {
        let removeSetupPlayer,
            mediaId = id;
        if (window?.setGlobalEvar === undefined) {
            window.setGlobalEvar = setGlobalEvar;
        }
        if (mediaId === 'tv3' && window.geoZoneHandler) {
            window.geoZoneHandler.getGeoZone((geo) => {
                if (removeSetupPlayer) {
                    removeSetupPlayer();
                }
                removeSetupPlayer = setupPlayer(GEO_ZONE_DICTIONARY_CHANNELS[geo]);
                window.addEventListener('changeVideo', nextVideo);
            });
        } else {
            if (removeSetupPlayer) {
                removeSetupPlayer();
            }
            removeSetupPlayer = setupPlayer(mediaId);
            window.addEventListener('changeVideo', nextVideo);
        }
        if (eliminarPrimerTabIndex) {
            document.addEventListener('focusin', removeTabIndex);
        }
        return () => {
            window.removeEventListener('changeVideo', nextVideo);
            window.removeEventListener('focusin', removeTabIndex);
            removeSetupPlayer();
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, reloadStartOver]);

    const handleStartOver = (ev) => {
        let data = ev.params || ev.detail || ev;
        let actiu = data?.actiu || false;
        let concat = '#';
        let audioIndex = getCurrentAudioTrack(globalController);
        let urlSplited = router.asPath?.split('#');
        let url = urlSplited[0];
        let hash = urlSplited[1] !== undefined ? '#' + urlSplited[1] : '#';
        hash = getCleanHash(hash);
        if (hash !== '#') {
            url = url + hash;
            concat = '&';
        }
        if (actiu) {
            url = url + concat + startOverPlayer;
        }
        if (audioIndex > 0) {
            let audioParam = '#audioIndex=';
            if (url.includes('#')) {
                audioParam = '&audioIndex=';
            }
            url = url + audioParam + audioIndex;
        }
        router.replace(url, undefined, { scroll: false });
        setReloadStartOver(actiu);
    };

    const getCleanHash = (hash) => {
        let cleanHash = hash;
        if (cleanHash.includes('#so_id')) {
            cleanHash = cleanHash.split('so_id')[0];
        }
        if (cleanHash.includes('&so_id')) {
            cleanHash = cleanHash.split('&so_id')[0];
        }
        if (cleanHash.includes('#audioIndex')) {
            cleanHash = cleanHash.split('audioIndex')[0];
        }
        if (cleanHash.includes('&audioIndex')) {
            cleanHash = cleanHash.split('&audioIndex')[0];
        }
        return cleanHash;
    };

    useEffect(() => {
        if (startOverPlayer !== null) {
            window.removeEventListener('startOver', handleStartOver);
            window.addEventListener('startOver', handleStartOver);
            if (globalController) {
                globalController.off('startOver', handleStartOver);
                globalController.on('startOver', handleStartOver);
            }
        }
        return () => {
            if (globalController) {
                globalController.off('startOver', handleStartOver);
            }
            window.removeEventListener('startOver', handleStartOver);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startOverPlayer]);

    useEffect(() => {
        if (globalController && !next) {
            let aud = audioDescPlayer ? 'activaAud' : 'desactivaAud';
            globalController?.sendCommand(aud);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [audioDescPlayer]);

    useEffect(() => {
        const updateFullScreen = () => {
            renderFullscreen();
        };
        if (globalController && tipus === 'video') {
            globalController.on('loadedmetadata', updateFullScreen);
            globalController.on('ready', updateFullScreen);
        }

        return () => {
            if (globalController) {
                globalController.off('loadedmetadata', updateFullScreen);
                globalController.off('ready', updateFullScreen);
            }
            // Limpiar el root cuando el componente se desmonte o las dependencias cambien
            if (fullscreenRootRef.current) {
                fullscreenRootRef.current.unmount();
                fullscreenRootRef.current = null;
            }
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [titol, nomProg, edat, aud, textAudPlayer, audioDescPlayer]);

    const playerBackground =
        (tipus !== 'audio' && !directe) || isPopup
            ? getImatge(imatges, 'web_player_poster_background', null, getCropByViewport(viewport), null).src
            : '';
    const stylesBackground = playerBackground
        ? {
              backgroundImage: 'url(' + playerBackground + ')',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              width: '100%'
          }
        : {};

    return (
        <>
            <Head>
                <link rel='stylesheet' type='text/css' href='https://statics.3cat.cat/css/vendor/bitmovinplayer-ui.min.css' />
                <link rel='stylesheet' type='text/css' href='https://statics.3cat.cat/css/moduls/skin.3cat.css' />
            </Head>

            <div style={stylesBackground}>
                <Script src='https://statics.3cat.cat/js/vendor/notification.center.min.js' />
                <Script src='https://statics.3cat.cat/js/vendor/springstreams.min.js' />
                {modelFetched && (
                    <div
                        className={`${stylesRmplayer} ${inactiveButtons} ${inactiveStartOverButton}`}
                        data-testid={`player-${id}`}
                    >
                        <BotonsAccesibilitat key={id} controlsAccessibles={controlsAccessibles} accessKeyAttr={accessKey} />
                        <div
                            ref={containerRef}
                            className='tvcplayer videoplayer'
                            data-audio-route-path='/catradio/alacarta/{slug2}/{slug}/audio/{id}/'
                            data-autoadjustheight='1'
                            data-autofullscreen={dataAutoFullScreen ? '1' : '0'}
                            data-autoplay={dataAutoPlay ? '1' : '0'}
                            data-blacklist='https://dinamics.3cat.cat/public/player/blacklist.json'
                            data-buttons='{}'
                            data-controls-accessibles={controlsAccessibles ? '1' : '0'}
                            data-delayed={dataDelayed || '0'}
                            data-durada={durada}
                            data-extrawsparams={dataParametresExtraWs}
                            data-idint={id}
                            data-jwskin='ccma'
                            data-skin='ccma'
                            data-jwskinaudio='ccma'
                            data-live={directe ? '1' : '0'}
                            data-mostra_event_fs=''
                            data-mostra_relacionats={dataMostraRelacionats ? '1' : '0'}
                            data-mostracasting={mostraCasting ? '1' : '0'}
                            data-popupurl='https://www.3cat.cat/audio/popup/'
                            data-producte=''
                            data-publivastios=''
                            data-img-src=''
                            data-type={tipus}
                            data-versio='vast'
                            data-video-route-path='/tv3/alacarta/{slug2}/{slug}/video/{id}/'
                            data-disableddobleclickfullscreen={disabledDblClickFullscreen}
                            data-vr=''
                        >
                            {isActive && !isGeoBlocked ? (
                                <VideoBase
                                    fixed={fixedPlayer}
                                    playerVideoTagId={playerVideoTagId}
                                    handlerCloseFlotant={handlerCloseFlotant}
                                />
                            ) : (
                                <div className={styles.errorContent} data-testid='player-error'>
                                    <div className={styles.errorLayer}>
                                        <div className={styles.errorMsg}>
                                            <div className={styles.errorText}>
                                                {!isGeoBlocked && <Icona icona='avis' alt='avis' isBlanc={true} mida={73} />}
                                                <div className={styles.errorTextContent}>
                                                    <div className={styles.textPrincipal}>
                                                        {tipus === 'audio' || tipus === 'audio_tts'
                                                            ? 'Contingut no disponible'
                                                            : 'Vídeo no disponible'}
                                                    </div>
                                                    <div className={styles.text}>{errorMessage}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
});

export default Player;
